<template>
  <form
    ref="formRef"
    method="post"
    class="header-search"
    @submit.prevent="handleSubmit"
  >
    <div class="header-search__input-wrapper">
      <input
        ref="input"
        v-model="resultRequestParams.keyword"
        class="header-search__input"
        type="search"
        placeholder="Search by company name or category or city"
        aria-label="Search by company name or category or city"
        @keyup="handleInputChange"
        @focus="hasFocus = true"
        @blur="hasFocus = false"
      >

      <button
        v-if="resultRequestParams.keyword"
        type="button"
        class="header-search__clear"
        @click.prevent="handleInputClear"
      >
        <span class="hidden-text">Clear search field</span>
        <img
          src="/img/icon/clear-blue.svg"
          alt="Clear search field"
          class="header-search__icon-clear"
        >
      </button>
    </div>
    <button
      type="submit"
      class="header-search__button"
      :disabled="!resultRequestParams.keyword"
    >
      <span class="hidden-text">Search by company name or category or city</span>
      <img
        src="/img/icon/search-icon.svg"
        alt="Search"
        class="header-search__icon"
        width="26"
        height="26"
      >
    </button>
    <div
      v-if="resultRequestParams.keyword"
      ref="resultsRef"
      class="header-search-results"
      :style="{
        maxHeight: resultsMaxHeight,
      }"
    >
      <span
        v-if="resultRequestParams.keyword && !results.length"
        class="header-search-results__listing header-search-results__listing--error"
      >
        Start typing to search...
      </span>
      <a
        v-for="result in results"
        :key="result.id"
        :href="result.route"
        class="header-search-results__listing"
      >
        {{ result.name }}
      </a>
    </div>
  </form>
</template>

<script>
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

export default {
  props: {
    apiRoutes: { required: true, type: Object },
    submitRoute: { required: true, type: String },
  },
  data() {
    return {
      loading: true,
      hasFocus: false,
      filterSettings: null,
      results: [],
      resultRequestParams: {
        order_by: 'ASC',
        sort_by: 'name',
        filter_by: 'category.slug',
        filter: null,
        keyword: '',
        proximity: 'unlimited'
      },
      resultsMaxHeight: '70vh',
    };
  },
  watch: {
    hasFocus: function (value) {
      const body = document.body;
      if (value) {
        body.classList.add('has-page-cover');
      } else {
        if (!this.results.length || !this.resultRequestParams.keyword) {
          body.classList.remove('has-page-cover');
          clearAllBodyScrollLocks();
        }
      }
    },
    results: function (value) {
      const resultsElement = this.$refs.resultsRef;
      if (value.length) {
        disableBodyScroll(resultsElement);
      } else {
        enableBodyScroll(resultsElement);
      }
    },
  },
  created() {
    // Wait 0.3s for user to stop typing before proceeding with request
    this.loadResults = _.debounce(this.loadResults, 300);
  },
  mounted() {
    this.setResultsMaxHeight();
  },
  methods: {
    setResultsMaxHeight() {
      const formElement = this.$refs.formRef;
      const spaceAtBottom = 30;
      this.resultsMaxHeight = `${
        window.innerHeight -
        (formElement.clientHeight + formElement.offsetTop) -
        spaceAtBottom
      }px`;
    },
    requestResults() {
      let data = {
        params: this.resultRequestParams,
      };
      const request = axios.get(this.apiRoutes.results, data);
      return request;
    },
    loadResults() {
      this.requestResults()
        .then((response) => {
          this.results = response.data.data;
        })
        .catch((error) => {
          let response = error.response;
          this.loading = false;
          console.log(response);
        });
    },
    handleSubmit() {
      if (this.resultRequestParams.keyword) {
          let encodedURI = encodeURIComponent(this.resultRequestParams.keyword);
          window.location = `${this.submitRoute}?keyword=${encodedURI}`;
      }
    },
    handleInputChange() {
      this.loadResults();
    },
    handleInputClear() {
      this.resultRequestParams.keyword = '';
      this.results = [];
      this.$refs.input.focus();
    },
    handleFilterChange() {
      if (this.resultRequestParams.keyword) {
        this.loadResults();
      }
    },
  },
};
</script>
